import React from 'react'
import { WithdrawalsLayer } from '../components/userPoint/WithdrawalsLayer'
import MasterLayout from '../masterLayout/MasterLayout'

export const WithdrawalsListPage = () => {
  return (
    <>
      <MasterLayout>
        <WithdrawalsLayer />
      </MasterLayout>
    </>
  )
}
